module.exports = __webpack_public_path__ + "img/face_ugly.e7fc3b28.svg";